interface ISubscriber {
  unsubscribe: () => void;
}

abstract class EventEmitter {
  private events: Map<string, Map<Symbol, (...args: any[]) => any>> = new Map();

  public subscribe = (
    eventName: string,
    callbackFn: () => any
  ): ISubscriber => {
    if (!this.events.get(eventName)) {
      this.events.set(eventName, new Map());
    }

    const event = this.events.get(eventName);
    const id = Symbol();
    event?.set(id, callbackFn);

    return {
      unsubscribe: () => {
        const subscribers = this.events.get(eventName);
        subscribers?.delete(id);
      },
    };
  };

  public emit = (eventName: string, ...args: any[]) => {
    const subscribers = this.events.get(eventName);

    if (!subscribers) return;

    for (const [, fn] of subscribers.entries()) {
      fn(...args);
    }
  };
}

export default EventEmitter;
